import { CMSDataType, SanityConfig } from '../../../components/types/common';

export type ComponentRegistry = {
  [key: string]: React.ElementType;
};

export interface AbstractComponentPropTypes {
  componentType: string;
}
export interface SanitizeComponentPropTypes extends AbstractComponentPropTypes, SanityConfig {}

export type ComponentTransformerRegistry = {
  [key: string]: (data: CMSDataType) => AbstractComponentPropTypes;
};

export type PageTransformerRegistry = {
  [key: string]: (data: CMSDataType) => CMSDataType;
};

export enum ComponentType {
  accordion_component = 'accordion_component',
  accordion_component_item = 'accordion_component_item',
  image_and_text = 'image_and_text',
  audio_player = 'audio_player',
  image_with_optional_cta = 'image_with_optional_cta',
  hero_banner = 'hero_banner',
  mega_menu = 'mega_menu',
  top_navigation = 'top_navigation',
  default = 'default',
  footer = 'footer',
  journey_timelines = 'journey_timelines',
  hero_component = 'hero_component',
  site_logo = 'site_logo',
  faq_groups = 'faq_groups',
  faq = 'faqs',
  news_timelines = 'news_timelines',
  rich_text_component = 'rich_text_component',
  quick_links_design_one = 'quick_links_design_one',
  quick_links_design_two = 'quick_links_design_two',
  awards_timelines = 'awards_timelines',
  about_amway_brands = 'about_amway_brands',
  amway_highlights = 'amway_highlights',
  steps_to_business_owner = 'steps_to_business_owner',
  download_links = 'download_links',
  amway_business_links = 'amway_business_links',
  banner_rich_text_component = 'banner_rich_text_component',
  amway_promises = 'amway_promises',
  meet_our_scientists = 'meet_our_scientists',
  notification = 'notification',
  me_panel = 'me_panel',
  featured_cards = 'featured_cards',
  shop_by_container = 'shop_by_container',
  featured_card_container = 'featured_display_cards_carousal',
  video_banner = 'video_banner',
  product_carousal_banner = 'product_carousal_banner',
  featured_articles_carousal = 'featured_articles_carousal',
  my_account_container = 'my_account_container',
  featured_display_card = 'featured_display_card',
  content_card = 'content_card',
  content_card_carousal = 'content_card_carousal',
  content_detail_gallery = 'content_detail_gallery',
  article_carousel = 'article_carousel',
  promotion_carousel = 'promotion_carousel',
  resource_carousel = 'resource_carousel',
  article_card = 'article_card',
  resource_card = 'resource_card',
  promotion_card = 'promotion_card',
  highlights_c = 'highlights_c',
  standard_banner_no_cta = 'standard_banner_no_cta',
  promotion_overview = 'promotion_overview',
  resource_overview = 'resource_overview',
  article_overview = 'article_overview',
  video_section = 'video_section',
  text_only = 'text_only',
  grid_view_image_gallery = 'grid_view_image_gallery',
}
